export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      files: [
        {
          fileId: 43,
          fileUuid: "files043",
          fileName: "txt01.txt",
          fileUri: "/txt/txt01.txt",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 42,
          fileUuid: "files042",
          fileName: "txt02.txt",
          fileUri: "/txt/txt02.txt",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 41,
          fileUuid: "files041",
          fileName: "txt03.txt",
          fileUri: "/txt/txt03.txt",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        }
      ]
    }
  }
}